<script setup lang="ts">
  import { useUser } from '@gat-ship/user'
  import {
    ModalSection,
    ModalSectionHeader,
    ModalSectionHeaderTitle,
    ModalSectionHeaderDescription
  } from '@gat-ship/vue-components'
  import { AccessRolesCollectionProvider } from '@gat-ship/access-control'
  import { CustomFieldsManager } from '@gat-ship/custom-fields'

  // The global AdministrationModal opens purely off `?admin=custom-fields` and is
  // mounted for every authenticated user, so this panel must gate itself — the
  // router CustomFieldsLayout enforces the same check via PageLayout access-props.
  const user = useUser()

  // No header Add button: the Custom/System field views own their own
  // Add/Reorder affordances. The access-roles collection is wrapped here (the
  // admin shell owns the access-control dependency); CustomFieldsManager, a
  // descendant, safely injects it via defineCustomFieldsView().
</script>

<template>
  <div
    v-if="!user.isTenantAdmin.value"
    class="text-muted-foreground p-10 text-center text-sm"
  >
    You don't have permission to customize fields.
  </div>
  <AccessRolesCollectionProvider v-else :fetch-on-mount="true">
    <!-- pt-3 offsets the modal's -mt-3 under-fade pull; pb-5 keeps the last
         row off the modal edge (the tenant-users panel precedent). -->
    <div class="flex flex-col gap-6 pb-5 pt-3">
      <ModalSection>
        <ModalSectionHeader>
          <ModalSectionHeaderTitle>Field Customization</ModalSectionHeaderTitle>
          <ModalSectionHeaderDescription>
            Configure fields and custom fields for your organization.
          </ModalSectionHeaderDescription>
        </ModalSectionHeader>
        <CustomFieldsManager />
      </ModalSection>
    </div>
  </AccessRolesCollectionProvider>
</template>
